import React, { memo } from 'react';
import styled from 'styled-components';

import AppointmentIcon from 'assets/v2/AppointmentIcon';
import { COLORS } from 'theme';
import { BOOKING_TYPE_TIME_LABELS } from 'utils/constants';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.coralDark};
    background: ${COLORS.coralLight};
    border-color: ${COLORS.coral};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.coral};
    }
  }
`;

function AppointmentTimeBookingTypeTag(props) {
  return (
    <StyledTag
      label={BOOKING_TYPE_TIME_LABELS.ARRIVE_BY}
      icon={<AppointmentIcon />}
      {...props}
    />
  );
}

export default memo(AppointmentTimeBookingTypeTag);
